module.exports = __webpack_public_path__ + "img/refused.498ac112.svg";